module.exports = __webpack_public_path__ + "static/media/white_back_icon.d9ca8d35.svg";